import type { ReactNode } from 'react'

import { RiskQuestionnaireQuestionThreadActivity } from '@/gen/inventory/v1/control_service_pb'

import { formatTimestamp } from '@/lib/date/date'

import { COMMENT_LABELS } from '@/components/shared/comment/labels'
import { TimelineItem } from '@/components/timeline/timeline-item'

type ThreadActivityRowProps = {
  activity: RiskQuestionnaireQuestionThreadActivity
  // Rendered above the comment, for surfaces that also show status badges.
  children?: ReactNode
}

// The author arrives resolved from the server — don't resolve it again per surface.
export const ThreadActivityRow = ({ activity, children }: ThreadActivityRowProps) => {
  const hasAuthor =
    activity.userId?.case === 'assessorUserId' || activity.userId?.case === 'recipientId'

  return (
    <TimelineItem
      userName={hasAuthor ? activity.userName || COMMENT_LABELS.unknownAuthor : undefined}
      avatarUrl={activity.avatarUrl}
      date={formatTimestamp(activity.createdAt, 'dateTime')}
    >
      {children}
      {activity.comment && <span className='whitespace-pre-wrap'>{activity.comment}</span>}
    </TimelineItem>
  )
}
